import { reducer as batches } from "./batches/slice";

export const reducer = {
  batches,
};
